import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
const db = firebase.firestore()
import {objectToArray, UUID} from '@/constantes/helpers'



const updateCantidadManual = (idProducto, nuevaCantidad, idChunk = null, idAlmacen) => {
  return new Promise(async (resolve, reject) => {
    const docPath = '/Franquicias/BvMprX2oCD7SnWGJHOd9/Almacenes/'+idAlmacen;
    const collectionRef = db.collection(`${docPath}/cantidades_productos`);

    try {
      if (idChunk) {
        // Si idChunk es conocido, actualizar directamente
        const chunkDocRef = collectionRef.doc(idChunk);
        const chunkDoc = await chunkDocRef.get();

        if (chunkDoc.exists) {
          await chunkDocRef.update({
            [`${idProducto}.cantidad_manual`]: nuevaCantidad
          });
          console.log(`Updated ${idProducto} in ${idChunk}`);
          resolve(`Updated ${idProducto} in ${idChunk}`);
        } else {
          console.log(`Chunk ${idChunk} not found.`);
          resolve(`Chunk ${idChunk} not found.`);
        }
      } else {
        // Si idChunk es null, buscar un chunk con espacio o crear uno nuevo
        const snapshot = await collectionRef.get();
        let updated = false;

        for (const doc of snapshot.docs) {
          const data = doc.data();
          const chunkSize = Object.keys(data).length;

          if (chunkSize < 100) {
            await doc.ref.update({
              [`${idProducto}.cantidad_manual`]: nuevaCantidad
            });
            console.log(`Updated ${idProducto} in existing chunk ${doc.id}`);
            resolve(`Updated ${idProducto} in existing chunk ${doc.id}`);
            updated = true;
            break;
          }
        }

        if (!updated) {
          // Crear un nuevo chunk si no se encontró espacio
          const newDocRef = collectionRef.doc();
          await newDocRef.set({
            [idProducto]: {
              cantidad_manual: nuevaCantidad
            }
          });
          console.log(`Created new chunk and updated ${idProducto}`);
          resolve(`Created new chunk and updated ${idProducto}`);
        }
      }
    } catch (error) {
      console.error(error);
      reject(error);
    }
  });
}
const store = {
  state: {
    almacenes: {},
  },
  getters: {
    almacenes: state => {
      return state.almacenes
    },
    indiceAlmacenes: state => {

      const almacenes = objectToArray(state.almacenes)

      return almacenes.filter(e => e.nombre)
    },
  },
  mutations: {
    ASIGNA_ALMACENES(state, almacenes) {
      state.almacenes = almacenes
    },
    ASIGNA_CANTIDADESV2_ALMACEN(state, datos) {
      //console.log("🚀 ~ ASIGNA_CANTIDADESV2_ALMACEN ~ datos:", datos)
      state.almacenes[datos.id]['cantidadesV2'] = datos.cantidadesV2
    },
  },
  actions: {

    guardarAlmacen({ getters }, almacen) {

      almacen.fecha_alta = new Date();

      return new Promise((resolve, reject) => {

        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.ALMACENES).add(almacen).then(doc => {
            resolve(doc)
          }).catch(e => {
            reject(e)
          })

      })

    },
    actualizarAlmacen({ getters }, props) {

      const {almacen, id_almacen} = props 

      if(almacen.idSucursal){
        delete almacen.idSucursal
      }

      if(almacen.id){
        delete almacen.id
      }

      if(almacen.fecha_alta){
        delete almacen.fecha_alta
      }

      return new Promise((resolve, reject) => {

        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.ALMACENES).doc(id_almacen)
          .update(almacen).then(() => {
            resolve()
          }).catch(e => {
            reject(e)
          })

      })

    },
    obtenerAlmacen({ getters }, props) {

      const {id_almacen} = props 

      return new Promise((resolve, reject) => {

        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
          .collection(FS_COLLECTIONS.ALMACENES).doc(id_almacen)
          .get().then((doc) => {

            if(!doc.exists) reject({error:"El documento no existe"})

            resolve(doc.data())
          }).catch(e => {
            reject(e)
          })

      })

    },
    obtenerAlmacenes({ getters, commit }) {

      return new Promise((resolve) => {

        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.INDICES).doc(FS_COLLECTIONS.ALMACENES)
        .onSnapshot(doc => {

          commit('ASIGNA_ALMACENES',doc.data() || {} )

          resolve()

        })  

      })

    },


    elimnarServiciosCasoAlmacen({getters},data){

      const {cantidad, id_almacen, id_producto,inventario} = data

    
      const cantidades = {
        [id_producto]:firebase.firestore.FieldValue.delete(),
      }

      return new Promise((resolve,reject) => {

        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.ALMACENES).doc(id_almacen).set({
          "servicios_casos__idx":cantidades,
        },{merge:true}).then(() => {
          resolve()
        }).catch(e => {
          reject(e)
        })

      })

    },


    
    async guardarCantidadEnAlmacen({getters, dispatch},data){

      const {cantidad, id_almacen, id_producto, esVersion2Productos} = data
      console.log('getters.franquicia.id', getters.franquicia.id);
      console.log('getters.almacenes', getters.almacenes);
      console.log('id_almacen', id_almacen);
      const cantidad_manual = parseFloat(cantidad);

      //buscar el id chunk donde se encuentra el idProducto
      const almacen = getters.almacenes[id_almacen]
      const almacenes = getters.almacenes;
      console.log("🚀 ~ guardarCantidadEnAlmacen ~ almacen:", almacen)
      let idChunk = null;
      if(almacen.listaPartesCantidades && esVersion2Productos){
        for(let i in almacen.listaPartesCantidades){
          let item = almacen.listaPartesCantidades[i];
          if(item[id_producto]){
            console.log('se encontro el id chunk:', i);
            idChunk = i;
            break; // Detiene el bucle
          }
        }

        await updateCantidadManual(id_producto, cantidad_manual, idChunk, id_almacen)

        almacenes[id_almacen]['cantidadesV2'][id_producto].cantidad_manual = cantidad_manual
        dispatch('asignarAlmacenes', almacenes)
        return true;
      }

    
      const cantidades = {
        [id_producto]:{
          cantidad_manual,
        },
      }

      return new Promise((resolve,reject) => {

        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.ALMACENES).doc(id_almacen).set({
          "cantidades_productos":cantidades,
        },{merge:true}).then(() => {
          resolve()
        }).catch(e => {
          reject(e)
        })

      })

    },

    actualizarInventario(){

    },
    guardarTraspasoEnAlmacen({getters},data){

      const {traspaso} = data 
      traspaso.tipo = "TRASPASO_ENVIADO"
      traspaso.fecha_alta = new Date()
  
      return new Promise((resolve,reject) => {
  
        const {id_almacen} = traspaso.origen
  
        const traspasos = {
          [UUID()]:traspaso,
        }
  
        db.collection(FS_COLLECTIONS.FRANQUICIAS).doc(getters.franquicia.id)
        .collection(FS_COLLECTIONS.ALMACENES).doc(id_almacen).set({traspasos},{merge:true}).then((doc) => {
          resolve(doc)
        }).catch(e => {
          reject(e)
        })
  
      })
      
    },

    async migrateDataAlmacenes() {
      console.log('Migration iniciada!');
      const docRef = db.doc('/Franquicias/BvMprX2oCD7SnWGJHOd9/Almacenes/DBa0Qa2Ql49wrKQiId6Z');
      const doc = await docRef.get();
    
      if (!doc.exists) {
        console.log('No such document!');
        return;
      }
    
      const data = doc.data();
      const cantidadesProductos = data.cantidades_productos;
    
      let batch = db.batch();
      let counter = 0;
      let docCounter = 1;
      let chunk = {};
    
      for (const [id, info] of Object.entries(cantidadesProductos)) {
        chunk[id] = info;
        counter++;
    
        if (counter === 100) {
          const newDocRef = docRef.collection('cantidades_productos').doc(`chunk_${docCounter}`);
          batch.set(newDocRef, chunk);
          docCounter++;
          counter = 0;
          chunk = {};
        }
      }
    
      // Handle remaining chunk
      if (counter > 0) {
        const newDocRef = docRef.collection('cantidades_productos').doc(`chunk_${docCounter}`);
        batch.set(newDocRef, chunk);
      }
    
      // Borrar el campo antiguo (opcional)
      //---batch.update(docRef, { cantidades_productos: admin.firestore.FieldValue.delete() });
    
      await batch.commit();
      console.log('Migration completed successfully!');
    },


    async cargarPartesDeCantidadesProductoAlmacen({commit}, idAlmacen ){
      const collectionRef = db.collection('/Franquicias/BvMprX2oCD7SnWGJHOd9/Almacenes/'+idAlmacen+'/cantidades_productos');
      const snapshot = await collectionRef.get();

      let allData = {};
      let listaPartesCantidades = {}
      snapshot.forEach(doc => {
        Object.assign(allData, doc.data());
        listaPartesCantidades[doc.id] = doc.data();
      });
      //commit('ASIGNA_CANTIDADESV2_ALMACEN', datos)
      return {allData, listaPartesCantidades};
    },

    asignarAlmacenes({commit}, almacenes ){
      commit('ASIGNA_ALMACENES', {})
      commit('ASIGNA_ALMACENES', almacenes || {} )
      return true;
    },


    

  },
}

export default store



// WEBPACK FOOTER //
// ./src/store/almacenes/index.js